<template>
    <home-layout>
        <slot></slot>
    </home-layout>
</template>
<script>
import { mapState } from 'vuex';
import HomeLayout from './HomeLayout';

export default {
    name: 'home-layout-container',
    computed: {
        ...mapState(['token']),
    },
    components: {
        HomeLayout,
    }
}
</script>



// WEBPACK FOOTER //
// HomeLayoutContainer.vue?5a4c901b